import { type Control, useFormState, useWatch } from 'react-hook-form';
import { Stack, Grid, Typography, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';

import { isNil } from '#packages/data-collection/libs/lodash';

export type OtherDetailsProps = {
  control: Control<EditAuditFormBackgroundData>;
};

export const OtherDetails = ({ control }: OtherDetailsProps) => {
  const { errors } = useFormState({
    control,
  });

  const {
    general: {
      heatingHotWater,
      domesticHotWater,
      renovations,
      operationHours,
    } = {},
  } = useWatch({
    control,
  });

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          sx={{ mb: 0.5 }}>
          <Grid container alignItems="center">
            <InfoIcon fontSize="inherit" />
            <span>&nbsp;Other details</span>
          </Grid>
        </Typography>
        <Grid container justifyContent="space-between">
          <Typography component="span" variant="body2">
            Heating Hot Water:
          </Typography>
          <Typography
            component="span"
            variant="body2"
            color={
              errors.general?.heatingHotWater
                ? 'error'
                : isNil(heatingHotWater)
                  ? 'textDisabled'
                  : 'textPrimary'
            }>
            {isNil(heatingHotWater) ? '—' : `${heatingHotWater} ft`}
          </Typography>
        </Grid>
        <Grid container justifyContent="space-between">
          <Typography component="span" variant="body2">
            Domestic Hot Water:
          </Typography>
          <Typography
            component="span"
            variant="body2"
            color={
              errors.general?.domesticHotWater
                ? 'error'
                : isNil(domesticHotWater)
                  ? 'textDisabled'
                  : 'textPrimary'
            }>
            {isNil(domesticHotWater) ? '—' : `${domesticHotWater} ft`}
          </Typography>
        </Grid>
        <Grid container justifyContent="space-between">
          <Typography component="span" variant="body2">
            Renovations:
          </Typography>
          <Typography
            component="span"
            variant="body2"
            color={
              errors.general?.renovations
                ? 'error'
                : isNil(renovations)
                  ? 'textDisabled'
                  : 'textPrimary'
            }>
            {renovations ?? '—'}
          </Typography>
        </Grid>
        <Grid container justifyContent="space-between">
          <Typography component="span" variant="body2">
            Operation Hours:
          </Typography>
          <Typography
            component="span"
            variant="body2"
            color={
              errors.general?.operationHours
                ? 'error'
                : isNil(operationHours)
                  ? 'textDisabled'
                  : 'textPrimary'
            }>
            {isNil(operationHours) ? '—' : `${operationHours} hrs`}
          </Typography>
        </Grid>
      </Stack>
    </Box>
  );
};
